import { action, makeObservable, observable } from "mobx";
import { SimpleEventDispatcher } from "ste-simple-events";

import { Store } from ".";
import { isWindowDefined } from "../../app/core/lib/utilities";
import { ListenLive, ListenLiveEvent } from "../../app/core/lib/listenLive";
import { logger } from "../../app/core/lib/logging";

const log = logger.getChild("Player.store");

export class Player {
    @observable
    ready = false;

    @observable
    playback = false;

    @observable
    inProgress = false;

    externalAction = new SimpleEventDispatcher<ListenLiveEvent>();

    @action
    onReady = (): void => {
        this.ready = true;
    };

    @action
    onPlay = (): void => {
        this.playback = true;
        this.inProgress = false;
    };

    @action
    onPause = (): void => {
        this.playback = false;
        this.inProgress = false;
    };

    @action
    onProgress = (): void => {
        this.inProgress = true;
    };

    constructor() {
        makeObservable(this);
    }

    togglePlayback = (store: Store, sectionName: string, batch?: () => void): void => {
        if (!this.ready) {
            log.error("IHR Player not ready");
            return;
        }
        this.dispatchAnalytics(store, sectionName);
        this.dispatchExternal();
        if (batch && typeof batch === "function") {
            batch();
        }
    };

    private dispatchAnalytics(store: Store, sectionName: string): void {
        store.onAnalyticsAction.dispatch({
            sectionName,
            context: `listen_live`,
            action: "click",
            pageName: store.page.currentPage
                ? `${store.microsite ? "microsite_" : ""}${store.page.currentPage.name}`
                : "",
            referrer: isWindowDefined() ? window.location.href : "",
        });
    }

    private dispatchExternal(): void {
        this.externalAction.dispatch({ action: this.playback ? ListenLive.PAUSE : ListenLive.PLAY });
    }
}
